import {
    ADD_SCHEDULERS_DETAILS_REQUEST,
    ADD_SCHEDULERS_DETAILS_SUCCESS,
    ADD_SCHEDULERS_DETAILS_FAILURE,
    VIEW_EMAIL_SETTING_DETAIL_REQUEST,
    VIEW_EMAIL_SETTING_DETAIL_SUCCESS,
    VIEW_EMAIL_SETTING_DETAIL_FAILURE
} from 'actions/SystemSettings/systemSettingsAction';
const initialState = {
    schedulerData: {},
    schedulerDetails: {},
    emailSettingData:{},
    emailSettingDetails:{}
};

export default function systemSettingReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case ADD_SCHEDULERS_DETAILS_REQUEST:
            return {
                ...state
            };
        case ADD_SCHEDULERS_DETAILS_SUCCESS:
            return {
                ...state,
                schedulerDetails: action.payload
            };
        case ADD_SCHEDULERS_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload
            };
        case VIEW_EMAIL_SETTING_DETAIL_REQUEST:
            return {
                ...state
            };
        case VIEW_EMAIL_SETTING_DETAIL_SUCCESS:
            return {
                ...state,
                emailSettingDetails: action.payload
            };
        case VIEW_EMAIL_SETTING_DETAIL_FAILURE:
            return {
                ...state,
                error: action.payload
            };
                 case 'EMAILSETTINGSDETAILSDATA':
            if (!action.payload) {
                return initialState;
            } else {
                return {
                    ...state,
                    emailSettingData: action.payload
                };
            }
        case 'EMAILSETTINGSDETAILS':
            if (!action.payload) {
                return initialState;
            } else {
                return {
                    ...state,
                    emailSettingDetails: action.payload
                };
            }
        case 'SCHEDULERDETAILSDATA':
            if (!action.payload) {
                return initialState;
            } else {
                return {
                    ...state,
                    schedulerData: action.payload
                };
            }
        case 'SCHEDULERDETAILS':
            if (!action.payload) {
                return initialState;
            } else {
                return {
                    ...state,
                    schedulerDetails: action.payload
                };
            }
        default:
            return state;
    }
}